export const productResourceFieldHelp = {
  name: {
    description: 'Nome do material como a equipe reconhece no catálogo e nos produtos vinculados.',
    example: 'One-pager bTalk para diretoria',
  },
  resourceType: {
    description: 'Formato do recurso: documento, template, vídeo, link, integração ou outro.',
    example: 'Link — para uma página ou arquivo na nuvem',
  },
  url: {
    description: 'Endereço do arquivo ou página. Opcional se o recurso ainda não tiver um destino publicado.',
    example: 'https://drive.google.com/arquivo-onepager',
  },
  description: {
    description: 'Para que serve este material e quando a equipe deve usá-lo.',
    example: 'Resumo executivo da plataforma para reunião de descoberta',
  },
} as const;
